import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import { ability } from './ability';
// Setup CASL Ability Context
// Reference: https://casl.js.org/v5/en/package/casl-react
export const AbilityContext = createContext(ability);
// Use Can as a HOC and provide the "I" and "a" props.
// I - User Action. e.g. create, update
// a - Subject. e.g. business, user, site
export const Can = createContextualCan(AbilityContext.Consumer);
